import axios from "axios";
import qs from "qs";
import { store } from "@/store";
import { Notify } from "vant";
class Http {
  openCancel = false;
  config = {};
  pending = [];
  cancelToken = axios.CancelToken;
  removePending(config) {
    for (const p in this.pending) {
      const item = Number(p);
      const list = this.pending[p];
      if (
        list.url === config.url + "&request_type=" + config.method &&
        !config.headers.noCancel
      ) {
        list.cancel("重复的请求");
        this.pending.splice(item, 1);
      }
    }
  }

  constructor(config) {
    this.config = config;
  }

  create(openCancel = false) {
    this.openCancel = openCancel;
    const instance = axios.create(this.config);
    this.addInterceptors(instance);
    return instance;
  }

  addInterceptors(instance) {
    instance.interceptors.request.use(
      (config) => {
        if (this.openCancel) {
          this.removePending(config);
          config.cancelToken = new this.cancelToken((c) => {
            this.pending.push({
              url: config.url + "&request_type=" + config.method,
              cancel: c,
            });
          });
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    instance.interceptors.response.use(
      (res) => {
        const { data, config } = res;
        if (this.openCancel) {
          this.removePending(config);
        }
        if (data.returncode != "0") {
          if (data?.returnmsg && !data?.returnmsg.includes("为0")) {
            Notify({ type: "danger", message: data.returnmsg });
          }
          return Promise.reject(data);
        }
        return data;
      },
      (error) => {
        if (error instanceof axios.Cancel) {
          return Promise.reject(error.message);
        }
        return Promise.reject(error);
      }
    );
  }
}

export const loginAxios = new Http({
  baseURL: process.env.VUE_APP_LOGIN_URL,
  paramsSerializer(params) {
    return qs.stringify(params);
  },
  timeout: 60 * 1000,
  withCredentials: false,
}).create();

export const api = new Http({
  paramsSerializer(params) {
    return qs.stringify(params);
  },
  transformRequest: [
    (data) => {
      switch (true) {
        case data instanceof FormData:
          break;

        default:
          data = qs.stringify({
            user_id: store.state.userInfo?.id,
            ...data,
          });
          break;
      }
      return data;
    },
  ],
  timeout: 60 * 1000,
  withCredentials: false,
}).create();
